import { render, staticRenderFns } from "./today-dep.vue?vue&type=template&id=51689adb&"
import script from "./today-dep.vue?vue&type=script&lang=js&"
export * from "./today-dep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports